import { UIHeading4, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { Avatar } from '../Avatar';

export interface IAuthorProps {
  name: string;
  date: string;
  rating?: React.ReactNode;
  avatarUrl: string;
}

export const Author: React.FC<IAuthorProps> = ({ name, date, rating, avatarUrl }) => {
  return (
    <div data-testid="Author" className={styles['root']}>
      <div className={styles['avatar']}>
        <Avatar avatarUrl={avatarUrl} />
      </div>
      <div className={styles['info-container']}>
        <div className={styles['name']}>
          <UIHeading4>{name}</UIHeading4>
        </div>
        <div className={styles['info']}>
          {rating}
          <UIText3>{date}</UIText3>
        </div>
      </div>
    </div>
  );
};
